export default __webpack_public_path__ + "static/media/home-vertical-portfolio-img-05.34bb7c6a.jpg";